import { Button } from '@/components/ui/button';
import { Eye, MoreHorizontal, Share2, Trash2, ShoppingBag } from 'lucide-react';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import LoginDialog from './auth/LoginDialog';
import { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface ListControlsProps {
  handleSave: () => void;
  handleShare: () => void;
  handleClearList: () => void;
  handleBuyList: () => void;
  isPending: boolean;
}

export const ListControls = ({ handleSave, handleShare, handleClearList, handleBuyList, isPending }: ListControlsProps) => {
  const { user } = useCurrentUser();
  const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false);

  const onPublishClick = () => {
    if (!user) {
      setIsLoginDialogOpen(true);
    } else {
      handleSave();
    }
  };

  return (
    <div className="w-full flex flex-col lg:flex-row gap-2">
      <div className="flex-grow">
        <div className="flex gap-2">
          <Button
            onClick={onPublishClick}
            disabled={isPending}
            className="w-full h-9 bg-gradient-to-r from-blue-800 to-slate-900 text-slate-200 hover:from-blue-700 hover:to-slate-800 transition-all duration-300 ease-in-out transform hover:scale-105"
          >
            <Eye className="h-4 w-4 mr-2" />
            {isPending ? 'Publishing...' : user ? 'Publish' : 'Log in to Publish'}
          </Button>
          <Button onClick={handleBuyList} variant="outline" className="h-9">
            <ShoppingBag className="h-4 w-4 mr-2" />
            Buy List
          </Button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="h-9 px-3">
                <MoreHorizontal className="h-4 w-4" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleShare}>
                <Share2 className="h-4 w-4 mr-2" />
                <span>Share</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleClearList}>
                <Trash2 className="h-4 w-4 mr-2" />
                <span>Clear List</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
      <LoginDialog isOpen={isLoginDialogOpen} onClose={() => setIsLoginDialogOpen(false)} onLogin={() => {}} />
    </div>
  );
};
